import $ from "jquery";

export const SetupPassword = function () {
	if (!($("#setup-password-form").length > 0)) return false;

	const $elms = {
		form: $("#setup-password-form"),
		password: $("#password"),
		repeatPassword: $("#repeat-password"),
		submitButton: $(".js-save-password"),
		passwordNote: $(".js-password-false"),
		passwordToggle: $(".js-password-toggle"),
	};

	const isResetPassword = $("#setup-password").hasClass("reset-password");

	const validatePassword = () => {
		const password = $elms.password.val();
		const repeatPassword = $elms.repeatPassword.val();

		// Check minimum length
		if (password.length < 8) {
			$elms.form.toggleClass("is-password-false", password.length > 0);
			$elms.passwordNote.text((window.CFG.strings?.authReset?.password_rule_info_text || "Je wachtwoord moet minimaal 8 tekens bevatten."));
			$elms.submitButton.prop("disabled", true);
			return false;
		}

		// Check if passwords match
		if (password !== repeatPassword) {
			$elms.form.toggleClass("is-password-false", repeatPassword.length > 0);
			$elms.passwordNote.text((window.CFG.strings?.authReset?.password_mismatch_text || "De wachtwoorden komen niet overeen."));
			$elms.submitButton.prop("disabled", true);
			return false;
		}

		// All validations passed
		$elms.form.removeClass("is-password-false");
		$elms.passwordNote.text("");
		$elms.submitButton.prop("disabled", false);
		return true;
	};

	validatePassword();

	// Add input event listeners for real-time validation
	$elms.password.on("input", validatePassword);
	$elms.repeatPassword.on("input", validatePassword);

	$elms.form.on("submit", function (e) {
		e.preventDefault();

		const password = $elms.password.val();
		const repeatPassword = $elms.repeatPassword.val();

		if (!validatePassword()) {
			return;
		}

		// Disable form during submission
		$elms.submitButton.prop("disabled", true);
		$elms.submitButton.addClass("is-loading");

		// Create FormData object
		const data = {
			action: "setup_password",
			password,
			repeat_password: repeatPassword,
			user_id: $elms.form.attr("data-user-id"),
			key: $elms.form.attr("data-reset-key"),
			login: $elms.form.attr("data-reset-login"),
			nonce: window.CFG.nonce,
		};

		$.ajax({
			url: window.CFG.ajaxUrl,
			type: "POST",
			data,
			success: function (response) {
				if (response.success) {
					// Handle success - redirect to provided URL
					window.location.href =
						window.CFG.siteURL +
						(isResetPassword
							? "/login?rpw=1"
							: "/profile-created/" + data.user_id);
				} else {
					// Handle error from server
					$elms.passwordNote.text(response.data?.message || (window.CFG.strings?.authReset?.save_failed_text || "Het opslaan is niet gelukt. Probeer het opnieuw."));
					$elms.form.addClass("is-password-false");
				}
			},
			error: function (xhr, status, error) {
				console.error(error);
				$elms.passwordNote.text((window.CFG.strings?.authReset?.save_connection_error_text || "Het opslaan is niet gelukt. Controleer je verbinding en probeer het opnieuw."));
				$elms.form.addClass("is-password-false");
			},
			complete: function () {
				// Re-enable form after submission
				$elms.submitButton.prop("disabled", false);
				$elms.submitButton.removeClass("is-loading");
			},
		});
	});

	$elms.passwordToggle.on("click", function () {
		const $this = $(this);
		const $input = $this.siblings(".input-text");
		const type = $input.attr("type");
		$input.attr("type", type === "password" ? "text" : "password");
		$this.toggleClass("is-password-false");
	});
};
